import { render } from "./attachment.vue?vue&type=template&id=3c6c85b4"
import script from "./attachment.vue?vue&type=script&lang=js"
export * from "./attachment.vue?vue&type=script&lang=js"

import "./attachment.vue?vue&type=style&index=0&id=3c6c85b4&lang=css"

import exportComponent from "C:\\Project\\VuePro\\ERP\\erp-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__